export default class {
    Id = null;

    Name = null;

    IsActive = true;

    Sorting = 0;

    mapFromDto(dto) {
        if(!dto)
            return this;
        
        this.Id = dto.Id;
        this.Name = dto.Name;
        this.IsActive = dto.IsActive;
        this.Sorting = dto.Sorting;

        return this;
    }

    mapToDto() {
        return JSON.parse(JSON.stringify(this));
    }

    isValid() {
        return Boolean(this.Name);
    }

}